import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import ReactJson from 'react-json-view';
import {getCastConfigs} from "../../../actions/actionCast"
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

class ViewCastConfig extends Component{
    constructor(props){
        super(props);
         this.state = {
            currentCastConfig: {}
        }
    }
  
    componentDidMount(){
        this.props.getCastConfigs();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.cast_configs.length > 0){
            let currentCastConfig = nextProps.cast_configs.find(cast_configs => cast_configs.cast_config_id === this.props.match.params.id);
            this.setState({currentCastConfig: currentCastConfig});
        }
    }

    render(){
        const {currentCastConfig} = this.state;
        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                               <strong>View Casting Config</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                    <div className="profile-table">
                                            {currentCastConfig ?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Id</h4></td><td>{currentCastConfig.cast_config_id ? currentCastConfig.cast_config_id : "-"}</td></tr>
                                                        <tr><td><h4>Key</h4></td><td>{currentCastConfig.key ? currentCastConfig.key : "-"}</td></tr>
                                                        <tr><td><h4>URL</h4></td><td>{ "https://" + window.location.host + "/#/cast/" +  currentCastConfig.key }</td></tr>
                                                        <tr><td><h4>Image</h4></td><td>{currentCastConfig.image_friendly_name ? currentCastConfig.image_friendly_name : "-"}</td></tr>
                                                        <tr><td><h4>Allow Resume </h4></td><td><img src={currentCastConfig.allow_resume ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Allow Anonymous </h4></td><td><img src={currentCastConfig.allow_anonymous ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Require ReCAPTCHA </h4></td><td><img src={currentCastConfig.require_recaptcha ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Anonymous User Group </h4></td><td>{currentCastConfig.group_name ? currentCastConfig.group_name: "-"}</td></tr>
                                                        <tr><td><h4>Limit Total Sessions </h4></td><td><img src={currentCastConfig.limit_sessions ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Sessions Remaining</h4></td><td>{currentCastConfig.limit_sessions ? currentCastConfig.session_remaining : "N/A"}</td></tr>
                                                        <tr><td><h4>Limit Requests Per IP </h4></td><td><img src={currentCastConfig.limit_ips ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Sessions Allowed </h4></td><td>{currentCastConfig.ip_request_limit ? currentCastConfig.ip_request_limit : "-"}</td></tr>
                                                        <tr><td><h4>Within Seconds </h4></td><td>{currentCastConfig.ip_request_seconds ? currentCastConfig.ip_request_seconds: "-"}</td></tr>
                                                        <tr><td><h4>Kasm URL</h4></td><td>{currentCastConfig.kasm_url ? currentCastConfig.kasm_url : "-"}</td></tr>
                                                        <tr><td><h4>Allow Dynamic Kasm URL Parameter</h4></td><td>{currentCastConfig.dynamic_kasm_url ? currentCastConfig.dynamic_kasm_url : "-"}</td></tr>
                                                        <tr><td><h4>Allow Dynamic Docker Network URL Parameter</h4></td><td>{currentCastConfig.dynamic_docker_network ? currentCastConfig.dynamic_docker_network : "-"}</td></tr>
                                                        <tr><td><h4>Error URL </h4></td><td>{currentCastConfig.error_url ? currentCastConfig.error_url : "-"}</td></tr>
                                                        <tr><td><h4>Disable Control Panel </h4></td><td><img src={currentCastConfig.disable_control_panel ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Disable Tips </h4></td><td><img src={currentCastConfig.disable_tips ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Enable Sharing </h4></td><td><img src={currentCastConfig.enable_sharing ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Disable Sharing Fixed Resolution</h4></td><td><img src={currentCastConfig.disable_fixed_res ? iconYes : iconNo} alt="yesNoIcon"/></td></tr>
                                                        <tr><td><h4>Restrict To Referrers</h4></td><td>
                                                            { currentCastConfig.allowed_referrers ?
                                                                <ReactJson src={currentCastConfig.allowed_referrers}
                                                                           name={false}
                                                                           collapsed={false}
                                                                           sortKeys={true}
                                                                           collapseStringsAfterLength={40}
                                                                           enableClipboard={false}
                                                                           displayDataTypes={false}
                                                                />
                                                                : "-"
                                                            }
                                                        </td></tr>
                                                    </tbody>
                                                </Table> : " "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );}
}

ViewCastConfig.propTypes = {
    cast_configs: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        cast_configs: state.cast.cast_configs || [],
    }),
dispatch => 
    ({  
        getCastConfigs: () => dispatch(getCastConfigs()),
    }))(ViewCastConfig);


// WEBPACK FOOTER //
// ./src/views/CastConfig/ViewCastConfig/ViewCastConfig.js